const scorePermissionEnum = {
  NONE: {
    code: 1,
    name: "NONE",
    desc: "没有权限",
    kind: "scorePermission"
  },
  READ: {
    code: 2,
    name: "READ",
    desc: "查看权限",
    kind: "scorePermission"
  },
  READ_AND_WRITE: {
    code: 3,
    name: "READ_AND_WRITE",
    desc: "读写权限",
    kind: "scorePermission"
  },
}

export default Object.freeze(scorePermissionEnum)